<template>
    <router-link :to="to" class="item">
        <font-awesome-icon v-if="show" class="icon" :icon="icon" />
    </router-link>
</template>

<script>
export default {
    name: 'NavLinkIcon',
    props: {
        icon: String,
        to: String,
        show: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.item {
    flex: auto;
    text-align: center;
}
.icon {
    color: white;
}
</style>
